/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Receiver_TitleInputs */

const vi_carrier_form_receiver_title = /** @type {(inputs: Carrier_Form_Receiver_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người nhận`)
};

/**

* @param {Carrier_Form_Receiver_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_receiver_title = /** @type {((inputs?: Carrier_Form_Receiver_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Receiver_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_receiver_title(inputs)
});